// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n::v-deep .vdialognew {\n  background-color: red;\n  box-shadow: none;\n}\n/deep/ .dialog .vdialognew .dialog--active .dialog--persistent {\n  background-color: red;\n}\n", ""]);
// Exports
module.exports = exports;
